import { render } from "./MainFooter.vue?vue&type=template&id=964484e0&ts=true"
import script from "./MainFooter.vue?vue&type=script&lang=ts"
export * from "./MainFooter.vue?vue&type=script&lang=ts"

import "./MainFooter.vue?vue&type=style&index=0&id=964484e0&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__